import {elaborate} from "./elaborate.js"
import {deserialize} from './historyUtils.js'
import {addSheet} from './addSheet'
import { getFunctionUrl } from "./functionEndpoints.js";

export const readHistory = async (metadata, spreadsheetAccessData) => {                      
  // read reviews from sheet
  // read cards from sheet info                                                                      
  let sheetTitle = ''
  if ( metadata.map(sheet => sheet.properties.title).includes('history')) {                            
    sheetTitle = 'history';                               
  } else {                                                                                           
    await addSheet('history', spreadsheetAccessData);
    return [{}, 0];
  }
  let existingHistory = [];
  if (window.localStorage.getItem('existingHistory')) {
    try {
      existingHistory = JSON.parse(window.localStorage.getItem('existingHistory'));
    }
    catch ( e ) {
      console.log('could not read existingHistory');
      window.localStorage.setItem('existingHistory', {})
    }
  }
  console.log('read existing history as', existingHistory)
  
  // this needs to eb the right length for elaborate()
  // eslint-disable-next-line
  let range = `${sheetTitle}!A:T`
  const url = getFunctionUrl('get-sheet-values')
  const requestBody = JSON.stringify({                                                               
    range: range,                                                                                    
    ...spreadsheetAccessData                                                                         
  });
  const req = await fetch(url, {body: requestBody, headers: {"Content-Type": "application/json"}, method: 'POST'})                                   
  const sheet = await req.json();
  const values = Array.isArray(sheet?.values) ? sheet.values : [];
  let reviewHistory = []
  values.forEach( (historyElement, review_id) => {
    if (historyElement[0] !== 'id') {
      reviewHistory.push(deserialize(historyElement));
      reviewHistory[reviewHistory.length - 1].review=review_id;
    }
  })
  const localHistory = existingHistory?.[spreadsheetAccessData.spreadsheetId];
  if (Array.isArray(localHistory) && localHistory.length > 0) {
    console.log(reviewHistory.slice(-1))
    let lastReview = -1;
    if (reviewHistory.length > 0) {
      lastReview = reviewHistory[reviewHistory.length - 1].review;
    }
    localHistory.forEach ( (historyElement, review_id) => {
      reviewHistory.push({...historyElement, review: 1 + lastReview + review_id });
    })
  }
  //
  // update cards by doing callback
  reviewHistory = elaborate(reviewHistory);
  let reviewHistoryDict = {};
  if (reviewHistory) {
    reviewHistory.forEach( rhe => {
      if (rhe.card_id in reviewHistoryDict) {
        let n = reviewHistoryDict[rhe.card_id].length; // length of old sequence
        reviewHistoryDict[rhe.card_id].push(rhe);
        if ( rhe.correct === undefined ) {
          //let correct = reviewHistoryDict[rhe.card_id].reduce((a,rh) => a + rh.was_correct)
          //let incorrect = reviewHistoryDict[rhe.card_id].reduce((a,rh) => a + 1 - rh.was_correct)
          reviewHistoryDict[rhe.card_id][n].correct = reviewHistoryDict[rhe.card_id][n-1].correct + reviewHistoryDict[rhe.card_id][n-1].was_correct
          reviewHistoryDict[rhe.card_id][n].incorrect = reviewHistoryDict[rhe.card_id][n-1].incorrect + 1 - reviewHistoryDict[rhe.card_id][n-1].was_correct
          reviewHistoryDict[rhe.card_id][n].delta_r =  rhe.review - reviewHistoryDict[rhe.card_id][n-1].review;
        }
        if (rhe.is_new === undefined) {
          reviewHistoryDict[rhe.card_id][n].is_new = false;
        }
      }
      else {
        reviewHistoryDict[rhe.card_id] = [rhe]
        reviewHistoryDict[rhe.card_id][0].delta_r = 0;
        if ( rhe.correct === undefined ) {
          reviewHistoryDict[rhe.card_id][0].correct = 0
          reviewHistoryDict[rhe.card_id][0].incorrect = 0
        }
        if (rhe.is_new === undefined) {
          reviewHistoryDict[rhe.card_id][0].is_new = true;
        }
      }
    })
  }
  for ( let card_id in reviewHistoryDict ) {
    let runningTotalFront = 0;
    let runningTotalBack = 0;
    let countFront = 0;
    let countBack = 0;
    for (let index = 0; index < reviewHistoryDict[card_id].length; index++) {
      if (index === 0) {
        reviewHistoryDict[card_id][index].last_ten = 0;
        reviewHistoryDict[card_id][index].front_prob = 0;
        reviewHistoryDict[card_id][index].back_prob = 0;
        continue;
      }
      
      /* side 0 or 1 is front or back, respectively */

      countFront += ! reviewHistoryDict[card_id][index].side_shown; 
      countBack  +=   reviewHistoryDict[card_id][index].side_shown;
      
      runningTotalBack += reviewHistoryDict[card_id][index].was_correct && (reviewHistoryDict[card_id][index].side_shown);
      runningTotalFront += reviewHistoryDict[card_id][index].was_correct && (! reviewHistoryDict[card_id][index].side_shown);
      
      reviewHistoryDict[card_id][index].last_ten = reviewHistoryDict[card_id].map( (x, i) => i > (index - 10 - 1) && (i < index) ? x.was_correct : 0).reduce((a, r) => r + a, 0) / 
        reviewHistoryDict[card_id].filter( (x, i) => i > (index - 10 - 1) && (i < index) ).length;
      reviewHistoryDict[card_id][index].front_prob = countFront ? runningTotalFront/countFront : 0;
      reviewHistoryDict[card_id][index].back_prob  = countBack ? runningTotalBack/countBack : 0;
    }
  }

  console.log(reviewHistoryDict) 
  return [reviewHistoryDict, reviewHistory.length]
}

export default readHistory;
